import { render, staticRenderFns } from "./AddressInspectorPanel.vue?vue&type=template&id=53ed97e4&scoped=true"
import script from "./AddressInspectorPanel.vue?vue&type=script&lang=ts"
export * from "./AddressInspectorPanel.vue?vue&type=script&lang=ts"
import style0 from "./AddressInspectorPanel.vue?vue&type=style&index=0&id=53ed97e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed97e4",
  null
  
)

export default component.exports